import Loading from './Loading'

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading/index.js